import React from "react";
import CheckmarkGreen from "./CheckmarkGreen";

/**
 * CourseCompletedPopup — web port of the iOS course-completion popup
 * (client-native/src/features/home/components/CourseCompletedPopup.tsx +
 * ui/molecules/Popup.tsx "medium": rgba(0,0,0,0.5) scrim, centered white card,
 * radius 16 / 24 for Flight School, padding 24, maxWidth 400, GreyLight
 * border). Copy, colors and the overlay-dismiss rule (non-FS only) match iOS.
 */
interface CourseCompletedPopupProps {
  visible: boolean;
  courseName: string;
  isFlightSchool: boolean;
  onPickNextCourse: () => void;
  onDismiss: () => void;
}

const CourseCompletedPopup: React.FC<CourseCompletedPopupProps> = ({
  visible,
  courseName,
  isFlightSchool,
  onPickNextCourse,
  onDismiss,
}) => {
  if (!visible) return null;

  return (
    <div
      onClick={onDismiss}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 60,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "0 20px",
        background: "rgba(0, 0, 0, 0.5)",
      }}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-label="Course completed"
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#ffffff",
          borderRadius: isFlightSchool ? 24 : 16,
          padding: 24,
          width: "100%",
          maxWidth: 400,
          border: "1px solid var(--color-grey-light)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          boxSizing: "border-box",
        }}
      >
        <CheckmarkGreen size={64} />
        <div
          style={{
            fontSize: 26,
            fontWeight: 700,
            color: "var(--color-text-primary)",
          }}
        >
          Congrats!
        </div>
        <div
          style={{
            fontSize: 15,
            fontWeight: 500,
            color: "var(--color-grey-other)",
            textAlign: "center",
            marginTop: 6,
            lineHeight: "22px",
            whiteSpace: "pre-line",
          }}
        >
          {isFlightSchool ? (
            <>
              You completed{" "}
              <span style={{ fontWeight: 700, color: "var(--color-text-primary)" }}>
                Flight School
              </span>
              {"!\n"}Let's jump into video courses.
            </>
          ) : (
            <>
              You finished{"\n"}
              <span style={{ fontWeight: 700, color: "var(--color-text-primary)" }}>
                {courseName}
              </span>
            </>
          )}
        </div>
        {/* iOS Button variant="primary" size="medium": blue pill, white base/semibold
            text, fullWidth, padding 16/12 (Button.tsx:201-216). */}
        <button
          type="button"
          onClick={onPickNextCourse}
          style={{
            marginTop: 24,
            width: "100%",
            minWidth: 100,
            padding: "12px 16px",
            borderRadius: 999,
            background: "var(--color-blue)",
            color: "#ffffff",
            border: "none",
            cursor: "pointer",
            fontSize: "var(--base-font-size)",
            fontWeight: 600,
          }}
        >
          {isFlightSchool ? "Okay, let's do it" : "Pick next course"}
        </button>
      </div>
    </div>
  );
};

export default CourseCompletedPopup;
